import { DOCUMENTS_CONFIG } from '../../../../../services/document/documentsConfig';
import {
  getRequiredDocuments,
  thirdPartyDocumentSelectedHandlers,
} from '../../../../../services/document/documentService';
import { VerificationContext } from '../../XState/Model';

export enum DocumentStatus {
  Requested,
  Received,
}

export const documentPanelsConfig = (context: VerificationContext) => {
  const { uploadedDocuments = [], workflow } = context || {};

  const requiredDocuments = getRequiredDocuments(workflow, context);

  return requiredDocuments.map((doc, index) => {
    const { alwaysAllowUpload, ...documentConfig } =
      DOCUMENTS_CONFIG[doc] || {};

    const isUploaded = uploadedDocuments.includes(doc) && !alwaysAllowUpload;

    const withoutCheckedBorder = doc in thirdPartyDocumentSelectedHandlers;

    return {
      ...documentConfig,
      key: index.toString(),
      value: doc,
      status: isUploaded ? DocumentStatus.Received : DocumentStatus.Requested,
      subtitle: isUploaded ? 'Received' : 'Requested',
      disabled: isUploaded,
      withoutCheckedBorder,
    };
  });
};
